module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Markera som oläst":"Mark as unread"},"sv":{"Markera som oläst":"Markera som oläst"}}')
  delete Component.options._Ctor
}
